import { StrikethroughOutlined } from '@ant-design/icons'
import { Flex } from 'antd'

import { useSelectionTextFormat } from '../../hooks/useSelectionTextFormat'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { MenuButton } from '../../ui/MenuButton'

export const StrikethroughButton = () => {
  const [strikethrough, toggleStrikethrough] =
    useSelectionTextFormat('strikethrough')

  return (
    <MenuButton
      actived={strikethrough}
      tooltip={
        <Flex vertical align='center'>
          <span>删除线</span>
          <span>{SHORTCUTS.STRIKETHROUGH}</span>
        </Flex>
      }
      onClick={toggleStrikethrough}
    >
      <StrikethroughOutlined />
    </MenuButton>
  )
}
